// Coordinates digitized from RUC's official campus life map (2024-03).
// Units are source-map pixels. Heights and the southeast Lide footprint are interpretive.
export const boundary = [[110,239],[404,190],[800,177],[871,190],[898,391],[940,603],[950,695],[703,732],[461,774],[111,773]];
export const roads = [
 {name:'汇贤路',points:[[109,408],[262,398],[402,397],[685,397],[780,405],[900,405]],width:12},
 {name:'明志路',points:[[340,475],[486,475],[687,475],[782,475]],width:10},
 {name:'吴玉章路',points:[[486,565],[567,565],[689,565],[782,555],[916,555]],width:10},
 {name:'静园路',points:[[109,641],[263,641],[340,641],[486,641],[567,641],[689,641],[782,641],[878,641],[916,641]],width:11},
 {name:'友谊路',points:[[486,696],[567,696],[689,696],[782,696],[878,696],[943,696]],width:10},
 {name:'林园路',points:[[781,189],[781,270],[780,405],[782,475],[782,555],[782,641],[782,696]],width:10},
 {name:'崇德路',points:[[404,190],[402,260],[402,397]],width:10},
 {name:'知行路',points:[[262,221],[262,310],[262,398],[263,475],[263,641]],width:9},
 {name:'品园路',points:[[194,413],[194,521],[194,641]],width:7},
 {name:'',points:[[329,251],[329,310],[329,397]],width:7},
 {name:'',points:[[456,202],[456,270],[456,331],[456,397]],width:7},
 {name:'',points:[[524,202],[524,270],[524,331],[524,397]],width:7},
 {name:'',points:[[590,202],[590,270],[590,331],[590,397]],width:7},
 {name:'',points:[[402,202],[456,202],[524,202],[590,202],[628,202]],width:7},
 {name:'',points:[[402,270],[456,270],[524,270],[590,270],[702,274],[735,265],[781,270]],width:7},
 {name:'',points:[[329,310],[402,310]],width:6},
 {name:'',points:[[262,251],[329,251],[402,251]],width:7},
 {name:'',points:[[262,310],[329,310]],width:7},
 {name:'',points:[[340,408],[340,475],[340,641]],width:8},
 {name:'',points:[[486,475],[486,565],[486,641],[486,696]],width:8},
 {name:'',points:[[567,565],[567,641],[567,696]],width:8},
 {name:'',points:[[687,397],[687,475],[689,565],[689,641],[689,696]],width:8},
 {name:'',points:[[878,641],[878,696]],width:8},
 {name:'东门',points:[[782,593],[914,593],[940,593]],width:13},
 {name:'',points:[[916,555],[927,573],[927,615],[916,641]],width:8},
 {name:'',points:[[115,694],[263,694],[340,694],[455,694],[461,763]],width:7},
 {name:'',points:[[340,641],[340,694]],width:7},
];
const B=(id,name,x,y,w,d,h,type='academic',style='classic',extra={})=>({id,name,x,y,w,d,h,type,style,...extra});
export const buildings=[
 B('mingde','明德楼群',185,308,123,160,56,'academic','mingde',{featured:true,desc:'红砖楼群环抱明德广场，由明德主楼及法学、商学、新闻、国际等楼宇组成。',entrance:[187,398]}),
 B('mingdetang','明德堂',185,247,50,36,20,'culture','hall',{entrance:[185,275]}),
 B('library','图书馆',724,312,67,76,36,'culture','library',{featured:true,desc:'位于校园东北部，深色石材与悬挑屋顶围合空透柱廊，圆柱、横梁与玻璃门厅构成入口。',entrance:[748,397]}),
 B('guoxue','国学馆',647,336,96,90,28,'academic','courtyard',{featured:true,entrance:[645,397]}),
 B('shiji','世纪馆',371,558,35,133,27,'sport','gym',{featured:true,entrance:[340,554]}),
 B('archive','藏书馆',624,522,66,42,29,'culture','traditional',{featured:true,entrance:[624,565]}),
 B('humanities','人文楼',532,602,55,49,41,'academic','humanities',{featured:true,entrance:[552,641]}),
 B('qiushi','求是楼',733,605,66,52,26,'academic','courtyard',{featured:true,entrance:[733,641]}),
 B('liede','立德楼',901,658,53,64,49,'academic','modern',{featured:true,approx:true,desc:'东南区的现代教学楼，与立德公寓相连。外观参考校方介绍和央视实拍，轮廓与高度为近似。',entrance:[878,663]}),
 B('liede-dorm','立德公寓',898,706,73,17,49,'living','modern',{approx:true,entrance:[878,696]}),
 B('rushun','逸夫会堂',724,500,83,29,16,'culture','hall',{entrance:[722,565]}),
 B('arts','艺术学院',551,501,65,27,19,'academic'),
 B('museum','博物馆',520,526,55,26,16,'culture'),
 B('finance','财政金融学院',505,503,20,35,22),
 B('teach1','公共教学一楼',725,665,69,34,18),
 B('teach2','公共教学二楼',625,665,99,30,31),
 B('teach3','公共教学三楼',526,667,63,38,18),
 B('teach4','公共教学四楼',815,209,62,45,15),
 B('info','信息楼',710,194,130,21,22),
 B('mingli','明理楼',739,434,55,39,20),
 B('culture','文化大厦',884,444,32,51,60,'academic','modern'),
 B('mingzhi','明志楼',862,209,25,41,39,'academic','modern'),
 B('ligong','理工楼',638,450,59,24,18),
 B('ligong-annex','理工楼配楼',607,430,35,26,15),
 B('student','学生活动中心',541,438,67,19,14,'culture'),
 B('complex','综合服务楼',514,410,76,20,16,'service'),
 B('physics','物理学系',456,450,57,20,14),
 B('environment','环境学院',444,420,47,22,16),
 B('alumni','校友之家',424,461,41,13,8,'culture'),
 B('sociology','社会与人口学院',419,439,33,19,13),
 B('hospital','校医院',335,733,51,43,18,'service'),
 B('pool','游泳馆',455,700,39,73,12,'sport','gym'),
 B('sport-office','体育部',469,602,23,56,14,'sport'),
 B('westcanteen','西区食堂',147,548,40,89,13,'dining'),
 B('northcanteen','北区食堂',274,257,27,58,16,'dining'),
 B('middlecanteen','中区食堂',656,421,33,34,17,'dining'),
 B('eastcanteen','东区食堂',806,666,44,38,17,'dining','classic',{featured:true,entrance:[806,641]}),
 B('huixian','汇贤大厦',148,453,58,65,33,'service','courtyard'),
 B('hong1','红一楼',826,522,77,16,13,'living'),
 B('hong2','红二楼',826,477,77,18,13,'living'),
 B('hong3','红三楼',826,437,77,16,13,'living'),
 B('dong7','东风七楼',886,498,54,16,17,'living'),
 B('dong4','东风四楼',885,537,53,15,17,'living'),
 B('dong6','东风六楼',848,666,35,31,19,'living'),
 B('lin1','林园一楼',818,385,53,15,15,'living'),
 B('lin2','林园二楼',818,347,53,15,15,'living'),
 B('lin3','林园三楼',818,310,53,15,15,'living'),
 B('lin4','林园四楼',818,283,53,14,15,'living'),
 B('lin12','林园十二楼',664,260,123,16,16,'living'),
 B('zhixing1','知行一楼',365,264,60,23,37,'living','modern'),
 B('zhixing2','知行二楼',307,274,31,32,37,'living','modern'),
 B('zhixing3','知行三楼',377,221,23,30,47,'living','modern'),
 B('zhixing4','知行四楼',333,222,50,18,42,'living','modern'),
 B('zhixing5','知行五楼',297,229,28,19,42,'living','modern'),
 B('zhixing6','知行六楼',271,235,22,28,39,'living','modern'),
 B('yiyuan1','宜园一楼',300,369,47,18,25,'living'),
 B('yiyuan2','宜园二楼',280,337,22,29,36,'living','modern'),
 B('yiyuan3','宜园三楼',309,337,22,29,36,'living','modern'),
 ...[[15,431,377],[16,431,348],[17,431,317],[18,431,285],[19,431,251],[20,431,218],[8,493,387],[9,493,343],[10,493,314],[12,493,251],[13,493,220],[14,501,189],[1,556,376],[2,556,348],[3,556,311],[4,556,282],[5,556,253],[7,593,189],[22,366,293]].map(([n,x,y])=>B('jing'+n,'静园'+n+'楼',x,y,n===14?69:46,14,16,'living')),
 ...[[1,148,622,70,17],[2,225,618,46,17],[3,225,570,46,17],[4,225,519,46,18],[5,224,472,46,22],[6,298,620,63,18]].map(([n,x,y,w,d])=>B('pin'+n,'品园'+n+'楼',x,y,w,d,23,'living')),
 B('qingyang','青阳楼',208,658,120,15,17,'living'),
 B('training','国际文化交流中心',700,711,111,17,23,'service'),
 B('international1','留学生一楼',621,713,62,23,22,'living'),
 B('international2','留学生二楼',567,714,42,17,22,'living'),
 B('international3','留学生三楼',567,738,43,17,22,'living'),
 B('guest','静园招待所',497,729,23,34,18,'service'),
 B('young','青年公寓',792,706,63,18,26,'living'),
];
export const greens=[
 [364,347,55,75],[299,444,56,59],[225,442,42,52],[152,559,36,90],
 [381,438,70,56],[543,445,290,64],[620,601,102,60],[836,591,96,62],
 [736,449,65,46],[727,541,84,43],[548,508,35,54],[617,490,62,21],
 [559,221,56,34],[497,277,54,27],[499,323,57,16],
 [628,235,54,35],[213,597,31,20],[829,454,36,12],
 ...[238,269,299,331,361].map(y=>[431,y,45,10]),
 ...[267,296,331,360].map(y=>[556,y,49,10]),
 ...[299,331,369].map(y=>[819,y,52,13]),
];
export const places=[...buildings,
 {id:'field',name:'田径场',x:429,y:557,w:78,d:130,h:2,type:'sport',featured:true,entrance:[475,565]},
 {id:'lawn',name:'教二草坪',x:625,y:600,w:100,d:57,h:1,type:'landscape',featured:true,entrance:[624,641]},
 {id:'pond',name:'一勺池',x:360,y:449,w:25,d:17,h:1,type:'landscape',featured:true,entrance:[340,451]},
 {id:'qiushiyuan',name:'求是园',x:839,y:594,w:90,d:60,h:1,type:'landscape',entrance:[836,593]},
 {id:'shuangqu',name:'双趣园',x:367,y:349,w:51,d:70,h:1,type:'landscape',entrance:[365,397]},
 {id:'eastgate',name:'东门',x:936,y:593,w:10,d:28,h:10,type:'gate',featured:true,entrance:[940,593]},
 {id:'westgate',name:'西门',x:110,y:408,w:10,d:28,h:10,type:'gate',featured:true,entrance:[109,408]},
 {id:'northwestgate',name:'西北门',x:251,y:205,w:24,d:10,h:8,type:'gate',entrance:[262,221]},
 {id:'northeastgate',name:'东北门',x:782,y:178,w:24,d:10,h:8,type:'gate',entrance:[781,189]},
 {id:'basketball',name:'篮球场',x:298,y:550,w:61,d:63,h:1,type:'sport',entrance:[263,550]},
 {id:'tennis',name:'网球场',x:386,y:694,w:49,d:40,h:1,type:'sport',entrance:[386,694]},
 {id:'football',name:'北区足球场',x:712,y:235,w:121,d:34,h:1,type:'sport',entrance:[712,270]},
];
export const categories={all:{name:'全部',icon:'LayoutGrid',color:'#7b3948'},academic:{name:'教学',icon:'GraduationCap',color:'#a16652'},culture:{name:'文化',icon:'BookOpen',color:'#b38345'},living:{name:'生活',icon:'BedDouble',color:'#75979a'},dining:{name:'餐饮',icon:'Utensils',color:'#bd7856'},sport:{name:'运动',icon:'CircleDot',color:'#6b936f'},landscape:{name:'景观',icon:'Trees',color:'#6b936f'},gate:{name:'校门',icon:'DoorOpen',color:'#8b6379'},service:{name:'服务',icon:'Cross',color:'#74979c'}};
